import Collapse from '@mui/material/Collapse';
import { fuzzyInList } from '@utils/strings';
import React from 'react';
import { TransitionGroup } from 'react-transition-group';
import ExpandableListItem from '../ExpandableListItem';
import ListItem from '../ListItem';
import { GroupElementData, SingleElementData } from '../types';

type Props = {
	filter: string;
	data: Array<GroupElementData | SingleElementData>;
};

const ListItems = ({ filter, data }: Props) => (
	<TransitionGroup>
		{data
			.map((item) => ({ ...item, label: intl.tr(item.label) }))
			.filter(
				(item) =>
					!!(item as GroupElementData).children ||
					!filter ||
					item.label.toLowerCase().includes(filter) ||
					fuzzyInList((item as SingleElementData).tags, filter)
			)
			.map((item) => (
				<Collapse key={item.label}>
					{(item as GroupElementData).children ? (
						<ExpandableListItem label={item.label}>
							<ListItems
								filter={filter}
								data={(item as GroupElementData).children}
							/>
						</ExpandableListItem>
					) : (
						<ListItem
							editorComponent={(item as SingleElementData).editorComponent}
							icon={(item as SingleElementData).icon}
							label={item.label}
						/>
					)}
				</Collapse>
			))}
	</TransitionGroup>
);

export default ListItems;
